import React, { useEffect, useState } from "react";
import { Logo } from "./brand/Logo";
import { Button } from "./ui/button";
import { Menu, X, Download } from "lucide-react";

const NAV = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "industries", label: "Industries" },
  { id: "recommendations", label: "Recommendations" },
  { id: "contact", label: "Contact" },
];

const RESUME_URL =
  "https://customer-assets.emergentagent.com/job_psoft-consulting/artifacts/4bcwiez1_Vijay_Rajgopalan_Resume.pdf";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F7F5F0]/85 border-b border-border"
          : "bg-transparent"
      }`}
    >
      <div className="container-app flex items-center justify-between py-4">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          data-testid="header-brand-link"
        >
          <Logo />
        </a>

        <nav className="hidden lg:flex items-center gap-8" data-testid="header-nav">
          {NAV.map((n) => (
            <button
              key={n.id}
              onClick={() => scrollTo(n.id)}
              className="text-sm tracking-wide text-foreground/80 hover:text-accent transition-colors relative group"
              data-testid={`nav-link-${n.id}`}
            >
              {n.label}
              <span className="absolute left-0 right-0 -bottom-1 h-px bg-accent scale-x-0 group-hover:scale-x-100 origin-left transition-transform" />
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={RESUME_URL}
            target="_blank"
            rel="noopener noreferrer"
            download="Vijay_Rajgopalan_Resume.pdf"
            data-testid="header-resume-download"
          >
            <Button
              variant="outline"
              className="rounded-none border-foreground/30 hover:bg-foreground hover:text-background text-xs tracking-[0.2em] uppercase font-medium px-5 py-2 h-auto"
            >
              <Download className="w-3.5 h-3.5 mr-2" />
              Resume
            </Button>
          </a>
          <Button
            onClick={() => scrollTo("contact")}
            className="rounded-none bg-accent text-accent-foreground hover:bg-accent/90 text-xs tracking-[0.2em] uppercase font-medium px-5 py-2 h-auto"
            data-testid="header-contact-cta"
          >
            Schedule Consultation
          </Button>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2"
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#F7F5F0]/98 backdrop-blur-xl border-t border-border" data-testid="mobile-menu">
          <div className="container-app py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <button
                key={n.id}
                onClick={() => scrollTo(n.id)}
                className="text-left text-base py-2 border-b border-border/60"
                data-testid={`mobile-nav-link-${n.id}`}
              >
                {n.label}
              </button>
            ))}
            <div className="flex flex-col gap-3 pt-2">
              <a
                href={RESUME_URL}
                target="_blank"
                rel="noopener noreferrer"
                download="Vijay_Rajgopalan_Resume.pdf"
                data-testid="mobile-resume-download"
              >
                <Button variant="outline" className="w-full rounded-none">
                  <Download className="w-4 h-4 mr-2" /> Download Resume
                </Button>
              </a>
              <Button
                onClick={() => scrollTo("contact")}
                className="w-full rounded-none bg-accent text-accent-foreground"
                data-testid="mobile-contact-cta"
              >
                Schedule Consultation
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
